import { render, staticRenderFns } from "./SignupSelector.vue?vue&type=template&id=2cf00b06&scoped=true"
import script from "./SignupSelector.vue?vue&type=script&lang=js"
export * from "./SignupSelector.vue?vue&type=script&lang=js"
import style0 from "./SignupSelector.vue?vue&type=style&index=0&id=2cf00b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf00b06",
  null
  
)

export default component.exports